import React from "react";
import { Typography, TypographyProps, SxProps, Theme } from "@mui/material";
import { applyGradientTextSmall, GradientVariant } from "../../constants/gradient";

type SmallTextGradientProps = TypographyProps & {
  children: React.ReactNode;
  gradientVariant?: GradientVariant;
  sx?: SxProps<Theme>;
};

/**
 * Reusable Typography component with gradient text styling for small text
 * Perfect for captions, labels, badges, and secondary text
 */
const SmallTextGradient: React.FC<SmallTextGradientProps> = ({
  children,
  gradientVariant = "subtle",
  sx,
  ...props
}) => {
  return (
    <Typography
      {...props}
      sx={[
        (theme) => applyGradientTextSmall(theme, gradientVariant),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Typography>
  );
};

export default SmallTextGradient;

